export default __webpack_public_path__ + "static/media/greenrecovered.0ffb44f9.svg";